import { Box, Collapse, IconButton } from '@mui/material';
import { Text } from '@qwickapps/react-framework';
import { useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PsychologyIcon from '@mui/icons-material/Psychology';

export interface ThoughtBubblesProps {
  thoughts: string[];
  autoCollapse?: boolean;
}

export default function ThoughtBubbles({ thoughts, autoCollapse = true }: ThoughtBubblesProps) {
  const [expanded, setExpanded] = useState(!autoCollapse);

  if (!thoughts || thoughts.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        mb: 1,
        border: 1,
        borderColor: 'divider',
        borderRadius: 1,
        overflow: 'hidden',
        bgcolor: 'background.default',
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          p: 1,
          gap: 1,
          cursor: 'pointer',
          '&:hover': {
            bgcolor: 'action.hover',
          },
        }}
        onClick={() => setExpanded(!expanded)}
      >
        <PsychologyIcon sx={{ fontSize: 16, color: 'var(--theme-text-secondary)' }} />
        <Text variant="caption" style={{ flex: 1 }} customColor="var(--theme-text-secondary)">
          {autoCollapse ? 'Thinking process' : 'Agent thoughts'} ({thoughts.length})
        </Text>
        <IconButton
          size="small"
          sx={{
            transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.3s',
          }}
        >
          <ExpandMoreIcon sx={{ fontSize: 16 }} />
        </IconButton>
      </Box>

      {/* Thoughts list */}
      <Collapse in={expanded}>
        <Box sx={{ p: 1, pt: 0 }}>
          {thoughts.map((thought, index) => (
            <Box
              key={index}
              sx={{
                p: 1,
                mb: 0.5,
                bgcolor: 'background.paper',
                borderRadius: 1,
                fontSize: '0.875rem',
                color: 'text.secondary',
                fontStyle: 'italic',
                '&:last-child': {
                  mb: 0,
                },
              }}
            >
              <Text variant="caption" component="div">
                {thought}
              </Text>
            </Box>
          ))}
        </Box>
      </Collapse>
    </Box>
  );
}
